import React from "react";

export const PremiumLivestreamIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = "40",
  height = "40",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.6667 5.00015H31.6667M34.2 34.0235C34.7133 33.3985 35 32.5502 35 31.6668V11.6668C35 10.7835 34.7133 9.93349 34.2 9.31015C33.6917 8.68349 32.9983 8.33349 32.275 8.33349H17.3067C14.4317 8.33349 13.875 5.44849 11.3783 5.04349C10.9383 4.97182 10.4817 5.00015 10.0367 5.00015C8.44833 5.00015 7.655 5.00015 7.03 5.26515C6.23497 5.60308 5.60218 6.23647 5.265 7.03182C5 7.65349 5 8.44682 5 10.0352V31.6668C5 32.5502 5.28667 33.4002 5.8 34.0235C6.31 34.6485 7.00333 35.0002 7.72667 35.0002H32.2733C32.9967 35.0002 33.6883 34.6502 34.2 34.0235Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4987 28.3333C24.2668 28.3333 25.9625 27.631 27.2127 26.3807C28.463 25.1305 29.1654 23.4348 29.1654 21.6667C29.1654 19.8986 28.463 18.2029 27.2127 16.9526C25.9625 15.7024 24.2668 15 22.4987 15C20.7306 15 19.0349 15.7024 17.7847 16.9526C16.5344 18.2029 15.832 19.8986 15.832 21.6667C15.832 23.4348 16.5344 25.1305 17.7847 26.3807C19.0349 27.631 20.7306 28.3333 22.4987 28.3333Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PrivateShowsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = "40",
  height = "40",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.332 16.6667V13.3333C13.332 8.73167 15.397 5 19.9987 5C24.6004 5 26.6654 8.73167 26.6654 13.3333V16.6667M26.6654 23.3333V28.3333M5.83203 29.6667V22C5.83203 20.1333 5.83203 19.2 6.19536 18.4883C6.51465 17.8605 7.0246 17.35 7.65203 17.03C8.36536 16.6683 9.2987 16.6683 11.1654 16.6683H28.832C30.6987 16.6683 31.632 16.6683 32.3454 17.03C32.9725 17.3496 33.4825 17.8595 33.802 18.4867C34.1654 19.2 34.1654 20.1333 34.1654 22V29.6667C34.1654 31.5333 34.1654 32.4667 33.802 33.18C33.4825 33.8072 32.9725 34.3171 32.3454 34.6367C31.632 35 30.6987 35 28.832 35H11.1654C9.2987 35 8.36536 35 7.65203 34.6367C7.02485 34.3171 6.51494 33.8072 6.19536 33.18C5.83203 32.4683 5.83203 31.535 5.83203 29.6667Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaidMediaIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = "40",
  height = "40",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 15.6667C5 11.9333 5 10.0667 5.72667 8.64C6.36581 7.38564 7.38564 6.36581 8.64 5.72667C10.0667 5 11.9333 5 15.6667 5H24.3333C28.0667 5 29.9333 5 31.36 5.72667C32.6144 6.36581 33.6342 7.38564 34.2733 8.64C35 10.0667 35 11.9333 35 15.6667V24.3333C35 28.0667 35 29.9333 34.2733 31.36C33.6342 32.6144 32.6144 33.6342 31.36 34.2733C29.9333 35 28.0667 35 24.3333 35H15.6667C11.9333 35 10.0667 35 8.64 34.2733C7.38564 33.6342 6.36581 32.6144 5.72667 31.36C5 29.9333 5 28.0667 5 24.3333V15.6667Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.07 17.8502C23.19 18.7618 23.75 19.2185 23.75 20.0002C23.75 20.7818 23.19 21.2385 22.07 22.1502C21.7617 22.4035 21.4533 22.6418 21.1733 22.8385C20.9069 23.024 20.6346 23.2007 20.3567 23.3685C19.24 24.0468 18.68 24.3868 18.18 24.0102C17.68 23.6335 17.6333 22.8485 17.5417 21.2735C17.5162 20.8495 17.5023 20.4249 17.5 20.0002C17.5 19.6085 17.5167 19.1718 17.5417 18.7268C17.6333 17.1518 17.6783 16.3652 18.18 15.9902C18.68 15.6135 19.24 15.9535 20.3567 16.6318C20.6467 16.8085 20.925 16.9885 21.1733 17.1618C21.455 17.3585 21.7617 17.5968 22.07 17.8485"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TipsRequestsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = "40",
  height = "40",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 9.1665V27.4998C5 29.7998 8.73167 31.6665 13.3333 31.6665C15.21 31.6665 16.94 31.3565 18.3333 30.8332M18.3333 30.8332V17.4998M18.3333 30.8332C18.3333 33.1332 22.065 34.9998 26.6667 34.9998C31.2683 34.9998 35 33.1332 35 30.8332V17.4998M21.6667 14.1665V9.1665"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 13.3333C8.73167 13.3333 5 11.4667 5 9.16667C5 6.86667 8.73167 5 13.3333 5C17.935 5 21.6667 6.86667 21.6667 9.16667C21.6667 11.4667 17.935 13.3333 13.3333 13.3333Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 24.1668C18.3333 26.4668 22.065 28.3335 26.6667 28.3335C31.2683 28.3335 35 26.4668 35 24.1668M5 15.8335C5 18.1335 8.73167 20.0002 13.3333 20.0002C15.21 20.0002 16.9417 19.6902 18.3333 19.1668M5 21.6668C5 23.9668 8.73167 25.8335 13.3333 25.8335C15.21 25.8335 16.94 25.5235 18.3333 25.0002M26.6667 21.6668C22.065 21.6668 18.3333 19.8002 18.3333 17.5002C18.3333 15.2002 22.065 13.3335 26.6667 13.3335C31.2683 13.3335 35 15.2002 35 17.5002C35 19.8002 31.2683 21.6668 26.6667 21.6668Z"
      stroke="#FD3C84"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
